// extracted by mini-css-extract-plugin
var _1 = "XZswcME_";
var _2 = "XZswcME_";
export { _1 as "product-image", _2 as "productImage" }
